export { default } from './ShareWithYourFriends';
